import {
  BADGE_FIELD,
  BIND_PREFIX,
  DEFAULT_TAG_KEYS_FIELD,
  OPTION_LABEL_FIELD,
  OPTION_VALUE_FIELD,
  STAT_LABEL_FIELD,
  STAT_TOOLTIP_FIELD,
  STAT_VALUE_FIELD,
  TAG_KEYS_FIELD,
} from '../binding-enhancer/constants';

/**
 * Prop names supplied via structured or template `_bind.*` declarations.
 * Plain props with the same name are ignored — one binding mechanism per prop.
 */
export function collectBindTargetPropNames(
  rawProps: Readonly<Record<string, unknown>>,
): ReadonlySet<string> {
  const names = new Set<string>();
  for (const key of Object.keys(rawProps)) {
    if (!key.startsWith(BIND_PREFIX)) {
      continue;
    }
    const propName = key.slice(BIND_PREFIX.length);
    if (
      propName.length === 0 ||
      propName === OPTION_LABEL_FIELD ||
      propName === OPTION_VALUE_FIELD ||
      propName === TAG_KEYS_FIELD ||
      propName === DEFAULT_TAG_KEYS_FIELD ||
      propName === STAT_LABEL_FIELD ||
      propName === STAT_VALUE_FIELD ||
      propName === STAT_TOOLTIP_FIELD ||
      propName === BADGE_FIELD
    ) {
      continue;
    }
    names.add(propName);
  }
  return names;
}
